import ScriptsApi from '../api/scripts';

export default {
  namespaced: true,
  state: {
    scripts: [],
    categories: [],
    selectedScript: {
      title: '',
      text: '',
      language: '',
      description: '',
      category: '',
    },
    prompterScript: null,
  },
  getters: {
    allScripts: state => state.scripts,
    scriptCategories: state => state.categories,
    selectedScript: state => state.selectedScript,
    prompterScript: state => state.prompterScript,
  },
  actions: {
    setSelectedScript(context, script) {
      context.commit('SET_SELECTED_SCRIPT', script);
    },
    setPrompterScript(context, script) {
      // make sure that text is not more than 10,000 characters, as prompter has a limit of 10,000 characters
      if (script.text.length > 10000) {
        script.text = script.text.substring(0, 10000);
      }

      const languageCodes = {
        English: 'en',
        Finnish: 'fi',
        Swedish: 'sv',
        German: 'de',
        French: 'fr',
        Spanish: 'es',
      };

      if (languageCodes[script.language]) {
        script.language = languageCodes[script.language];
      }

      context.commit('SET_PROMPTER_SCRIPT', script);
    },
    clearPrompterScript(context) {
      context.commit('SET_PROMPTER_SCRIPT', null);
    },
    getScripts(context, language = 'en') {
      return new Promise(async (resolve) => {
        const scripts = await ScriptsApi.getScripts(language);
        // nest scripts by category
        const byCategory = {};
        scripts.forEach((s) => {
          if (byCategory[s.category]) {
            byCategory[s.category].push(s);
          } else {
            byCategory[s.category] = [s];
          }
        });
        context.commit('SET_SCRIPTS', byCategory);
        resolve(byCategory);
      });
    },
    getCategories(context) {
      return new Promise(async (resolve) => {
        const categories = await ScriptsApi.getCategories();
        context.commit('SET_CATEGORIES', categories);
        resolve(categories);
      });
    },
    saveScript(context, script) {
        return ScriptsApi.createScript(script);
    },
    updateScript(context, script) {
      return new Promise(async (resolve) => {
        const updatedScript = await ScriptsApi.updateScript(script);

        resolve(updatedScript);
      });
    },
    deleteScript(context, script) {
      return new Promise(async (resolve) => {
        const deletedScript = await ScriptsApi.deleteScript(script);

        resolve(deletedScript);
      });
    },
    async optimizeTranscript(context, { videoId, language }) {
      return ScriptsApi.optimizeTranscript(videoId, { language });
    },
  },
  mutations: {
    SET_SCRIPTS(state, scripts) {
      state.scripts = scripts;
    },
    SET_CATEGORIES(state, categories) {
      state.categories = categories;
    },
    SET_SELECTED_SCRIPT(state, script) {
      state.selectedScript = script;
    },
    SET_PROMPTER_SCRIPT(state, script) {
      state.prompterScript = script;
    },
  },
};
